module.exports = __webpack_public_path__ + "static/media/terms-of-use.470ed24d.pdf";